
import { resetpwd } from "@/api/api-basic";
import { Component, Vue } from "vue-property-decorator";
import { objAny } from "@/common/common-interface";
import sha256 from "js-sha256";
import i18n from "@/config/i18n";
@Component
export default class SystemConfigUserAdd extends Vue {
  private modalShow = false;
  private loading = true;
  private FormData: objAny = {};
  private modalTitle = i18n.t("user.resetPassword");
  private passwordRule = (rule: objAny, value: string, callback: Function) => {
    if (value === "") {
      callback(new Error(i18n.t("user.userPwdNull") + ""));
    } else if (value != this.formItem.password) {
      callback(new Error(i18n.t("user.userPwdTowError") + ""));
    } else {
      callback();
    }
  };
  /**
   * 新增表单验证
   */
  private ruleInline: objAny = {
    password: [
      {
        required: true,
        message: i18n.t("user.userPwdNull"),
        trigger: "blur",
        max: 18,
        min: 6
      }
    ],
    password2: [
      {
        required: true,
        validator: this.passwordRule,
        trigger: "blur"
      }
    ]
  };
  private formItem: objAny = {
    userId: "",
    password: "",
    password2: ""
  };

  public open(item: objAny) {
    if (!this.FormData.$el) {
      this.$nextTick((): void => {
        this.FormData = this.$refs["formItem"];
      });
    } else {
      this.handleReset();
    }
    this.modalShow = true;
    this.loading = false;
    this.formItem.userId = item.userPkId;
    this.formItem.password = "";
    this.formItem.password2 = "";
  }

  public handleSubmit(): void {
    (this.$refs["formItem"] as objAny).validate((valid: boolean) => {
      if (valid) {
        this.submitData();
      }
    });
  }
  public closeModal(): void {
    this.modalShow = false;
  }
  public handleReset() {
    this.FormData.resetFields();
  }
  async submitData(): Promise<void> {
    const params: objAny = {
      userPkIds: [this.formItem.userId],
      newPwd: sha256.sha256(this.formItem.password)
    };
    const ret = await resetpwd(params);
    if (ret.status === this.$config.apiStatus) {
      this.$Message.success(i18n.t("operationSucess"));
      this.$emit("success");
      this.modalShow = false;
    }
    // this.loading = false;
  }
}
